export default __webpack_public_path__ + "static/media/1488.398256b1.png";